import '@backstage/cli/asset-types';
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import '@backstage/ui/css/styles.css';
import ReactDOM from 'react-dom/client';
import App from './App';
import './theme/verdant.css';

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
